// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Mq16n","overflowing":"ReadFullNote_overflowing__2a78_"};